<script lang="ts" setup>
  import type { IGameData } from '#shared/types/games.types';
  import type { ICloseArgs } from '#shared/types/modal.types';

  const props = defineProps<{ game: IGameData }>();

  const emit = defineEmits<{ close: [ICloseArgs] }>();

  const { launchGame } = useGameLauncher();

  function closeModal() {
    emit('close', {});
  }

  async function onDepositClick() {
    closeModal();
    await stores.modals.showCashierModal();
  }

  async function onPlayClick() {
    if (stores.games.gameIsLaunching) return;
    await launchGame({ game: props.game, isDemoPlay: true });
    closeModal();
  }
</script>

<template>
  <UModal
    title="Need more practice?"
    description="You can play Demo for FREE"
    :close="{ onClick: closeModal }"
    :ui="{ content: 'overflow-y-hidden w-full max-w-[520px]' }"
  >
    <template #content>
      <div class="overflow-auto bg-[#242B34] flex flex-col gap-4 p-4">
        <CoreIcon
          class="size-6 absolute top-4 right-3 cursor-pointer text-white"
          name="mdi-close"
          @click="closeModal"
        />

        <h2 class="text-3xl text-white text-center font-semibold leading-none mb-1">Insufficient USD balance</h2>

        <CoreButton
          color="green"
          class="h-[52px] w-full uppercase text-white font-barlow text-[18px] font-extrabold"
          variant="solid"
          loading-auto
          @click="onDepositClick"
        >
          Deposit now
        </CoreButton>

        <CoreButton
          class="flex flex-col gap-4 py-0 md:py-0 h-[52px] w-full text-white font-barlow text-[18px] font-extrabold bg-[#cc9a05] hover:bg-[#cc9a05] hover:brightness-105 active:bg-[#cc9a05] active:brightness-95"
          variant="solid"
          color="neutral"
          :loading="stores.games.gameIsLaunching"
          :disabled="stores.games.gameIsLaunching"
          :aria-disabled="stores.games.gameIsLaunching"
          @click="onPlayClick"
        >
          <template v-if="!stores.games.gameIsLaunching">
            <span class="text-base leading-0 uppercase">USE PLAY MONEY (PM)</span>
            <span class="text-xs leading-0">Try the game for FREE</span>
          </template>
        </CoreButton>
      </div>
    </template>
  </UModal>
</template>
